import { BrowserModule  } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomepageComponent } from './views/homepage/homepage.component';
import { HeaderComponent } from './partials/header/header.component';
import { FooterComponent } from './partials/footer/footer.component';
import { LoginComponent } from './partials/login/login.component';
import { LoaderComponent } from './partials/loader/loader.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData, KeyValuePipe } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import * as Hammer from 'hammerjs';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';

import { MatDialogModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule, MatMenuModule, MatStepperModule,
         MatRadioModule, MatSelectModule, MatChipsModule, MatTooltipModule, MatSlideToggleModule } from '@angular/material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SignupComponent } from './views/signup/signup.component';
import { HistoryComponent } from './views/history/history.component';
import { DossierComponent } from './views/dossier/dossier.component';
import { CouponComponent } from './views/coupon/coupon.component';
import { ResetpasswordDialog } from './views/dialogs-password/resetpassword.component';

import { StateService } from './services/states.service';
import { AppService } from './services/app.service';
import { InterceptService } from './services/intercept.service';
import { DossierAddComponent } from './views/dossier-add/dossier-add.component';
import { DossierPostComponent } from './views/dossier-post/dossier-post.component';

import { DelegateClickDirective } from './directives/delegate-click-directive';
import { DragDropDirective } from './directives/drag-drop-directive';
import { TarifsComponent } from './views/tarifs/tarifs.component';
import { ShowRapportsArchivDialog } from './views/dialogs-show-file/show-rapports-archiv-dialog.component';
import { ShowFileDialog } from './views/dialogs-show-file/show-file-dialog.component';
import { ShowMultipleFilesDialog } from './views/dialogs-show-file/show-multiple-files-dialog.component';
import { RapportDialog } from './views/dialogs-rapport/rapport-dialog.component';
import { CourrierDialog } from './views/dialog-courrier/dialog-courrier.component';
import { InstructionDialog } from './views/dialogs-instruction/instruction-dialog.component';
import { DialogCredits } from './views/dialog-credits/dialog-credits.component';
import { RendezVous } from './views/rendez-vous/rendez-vous.component';
import { DialogHTML } from './views/dialogs-html/dialog-html.component';
import { DialogSalRefDetailDirect } from './views/dialog-salref-detail-direct/dialog-salref-detail-direct.component';
import { DashboardDialog } from './views/dialogs-dashboard/dashboard-dialog.component';
import { SafePipe } from './pipe/safePipe.component';
import { Validation } from './pipe/validation.component';
import { GenerateVoucher } from './views/dialogs-voucher/generate-voucher-dialog.component';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CookieService } from 'ngx-cookie-service';

import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MessValidemail } from './views/dialogs-messages/mess_validemail_dialog.component';
import { MessConfirmAbandon } from './views/dialogs-messages/mess_confirmabandon_dialog.component';
import { MessDelete } from './views/dialogs-messages/mess_delete_dialog.component';
import { MessChangeMDP } from './views/dialogs-messages/mess_changemdp_dialog.component';
import { MessConfirmEmail } from './views/dialogs-messages/mess_confirmemail_dialog.component';
import { MessLienExpire } from './views/dialogs-messages/mess_lien_expire_dialog.component';
import { SafeHtmlPipe } from './pipe/safeHtmlPipe.component';
import { RouteEvents } from './guard/router-events';
import { CommentCaMarcheComponent } from './views/comment-ca-marche/comment-ca-marche.component';
import { QuiSommesNousComponent } from './views/qui-sommes-nous/qui-sommes-nous.component';
import { SecuriteDonneesComponent } from './views/securite-donnees/securite-donnees.component';
import { NousContacterComponent } from './views/nous-contacter/nous-contacter.component';
import { DialogsErrorsComponent } from './views/dialogs-errors/dialogs-errors.component';
import { DialogsErrorsSystemComponent } from './views/dialogs-errors-system/dialogs-errors-system.component';
import { DialogsDuplicationComponent } from './views/dialogs-duplication/dialogs-duplication.component';
import { DialogsLoadingComponent } from './views/dialogs-loading/dialogs-loading.component';
import { DialogComparateurComponent } from './views/dialogs/dialog-comparateur/comparateur.component';
import { DialogDossierLabelComponent } from './views/dialogs/dialog-dossier-label/label.component';

import { SvgToggleComponent} from './views/svg-toggle/svg-toggle.component';
import { AvenantComponent } from './views/dossier-post/avenant/avenant.component';
import { RapportComponent } from './views/dossier-post/rapport/rapport.component';
import { UniteTempsPipe } from './pipe/uniteTemps.pipe';
import { MaxLengthPipe } from './pipe/maxLength.pipe';

import { EntrepriseInfoDialog } from './views/dialog-entreprise/dialog-entreprise-info.component';
import { DialogCommonError } from './views/dialogs-errors/dialog-common-error.component';
import { DialogConfirmation } from './views/dialogs-messages/dialog_confirmation.component';
import { DialogCommonMessage } from './views/dialogs-messages/dialog_common_message.component';
import { DialogQuestionMessage } from './views/dialogs-question/dialog-question-message.component';
import { LabelComponent } from './views/dossier/input/label/label.component';
import { GraphComponent } from './views/dialog-salref-detail-direct/graph/graph.component';
import { UploadPayslipComponent } from './views/dossier/upload-payslip/upload-payslip.component';
import { SinglePayslipComponent } from './views/dossier/upload-payslip/single-payslip/single-payslip.component';

import { DossierDelegationInitComponent } from './views/dossier-post/delegation-init/delegation-init.component';
import { UploadContractsComponent } from './views/dossier/upload-contracts/upload-contracts.component';
import { SingleContractComponent } from './views/dossier/upload-contracts/single-contract/single-contract.component';
import { ReadDocumentsComponent } from './views/dossier/read-documents/read-documents.component';
import { DossierInfoComponent } from './partials/dossier-info/dossier-info.component';
import { DossierDelegationComponent } from './views/dossier-delegation/dossier-delegation.component';
import { DossierInitPayslipComponent } from './views/dossier-init-payslip/dossier-init-payslip.component';
import { DialogsInitPayslipComponent } from './views/dialogs-init-payslip/dialogs-init-payslip.component';
import { DossierTabIdentityComponent } from './partials/dossier-tab-identity/dossier-tab-identity.component';


registerLocaleData(localeFr, 'fr');

export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any> {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    LoaderComponent,
    SignupComponent,
    HistoryComponent,
    DossierComponent,
    DossierAddComponent,
    DossierDelegationInitComponent,
    DossierPostComponent,
    DragDropDirective,
    DelegateClickDirective,
    TarifsComponent,
    ShowFileDialog,
    ShowMultipleFilesDialog,
    ShowRapportsArchivDialog,
    DialogComparateurComponent,
    DialogDossierLabelComponent,
    DashboardDialog,
    MessDelete,
    MessChangeMDP,
    MessValidemail,
    MessConfirmEmail,
    MessLienExpire,
    MessConfirmAbandon,
    EntrepriseInfoDialog,
    DialogCommonError,
    DialogConfirmation,
    RapportDialog,
    CourrierDialog,
    InstructionDialog,
    RendezVous,
    DialogCredits,
    DialogHTML,
    DialogSalRefDetailDirect,
    DialogsInitPayslipComponent,
    ResetpasswordDialog,
    GenerateVoucher,
    SafePipe,
    SafeHtmlPipe,
    Validation,
    CommentCaMarcheComponent,
    QuiSommesNousComponent,
    SecuriteDonneesComponent,
    NousContacterComponent,
    CouponComponent,
    DialogsErrorsComponent,
    DialogsErrorsSystemComponent,
    DialogsDuplicationComponent,
    DialogsLoadingComponent,
    SvgToggleComponent,
    AvenantComponent,
    RapportComponent,
    UniteTempsPipe,
    MaxLengthPipe,
    DialogCommonMessage,
    DialogQuestionMessage,
    LabelComponent,
    GraphComponent,
    UploadPayslipComponent,
    SinglePayslipComponent,
    UploadContractsComponent,
    SingleContractComponent,
    ReadDocumentsComponent,
    DossierInfoComponent,
    DossierDelegationComponent,
    DossierInitPayslipComponent,
    DossierTabIdentityComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatStepperModule,
    MatRadioModule,
    MatSelectModule,
    MatChipsModule,
    MatTooltipModule,
    MatSlideToggleModule,
    NgbModule,
    PdfViewerModule,
    NgbPaginationModule,
    MatAutocompleteModule
  ],
  providers: [StateService, AppService,RouteEvents, InterceptService, CookieService, KeyValuePipe,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: InterceptService,
			multi: true
    },
    { provide: LOCALE_ID, useValue: "fr-FR" },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig,
    }],
  entryComponents: [
    LoginComponent,
    ShowFileDialog,
    ShowMultipleFilesDialog,
    ShowRapportsArchivDialog,
    MessDelete,
    MessChangeMDP,
    MessValidemail,
    MessConfirmEmail,
    MessLienExpire,
    MessConfirmAbandon,
    EntrepriseInfoDialog,
    DialogCommonError,
    DialogConfirmation,
    DialogCommonMessage,
    DialogQuestionMessage,
    ReadDocumentsComponent,
    RapportDialog,
    CourrierDialog,
    InstructionDialog,
    RendezVous,
    DialogCredits,
    DialogsErrorsComponent,
    DialogsErrorsSystemComponent,
    DialogsDuplicationComponent,
    DialogsLoadingComponent,
    DialogComparateurComponent,
    DialogDossierLabelComponent,
    DialogHTML,
    DialogSalRefDetailDirect,
    DialogsInitPayslipComponent,
    DashboardDialog,
    ResetpasswordDialog,
    GenerateVoucher,
  ],

  bootstrap: [AppComponent]
})
export class AppModule { }
